import React from 'react';
import { Tooltip, SxProps } from '@mui/material';

import { IButtonTooltipProps } from './interfaces';
import { useStyles } from './styles';

const ButtonTooltip = ({
  children,
  title,
  sx,
  disableHover,
  open,
  manualClick,
}: IButtonTooltipProps) => {
  const classes = useStyles();
  const openProp = manualClick ? { open } : {};

  return (
    <Tooltip
      arrow
      title={title}
      disableHoverListener={disableHover}
      componentsProps={{
        tooltip: {
          sx: { ...classes.tooltip, ...sx?.tooltip } as SxProps,
        },
        arrow: {
          sx: classes.arrow,
        },
      }}
      PopperProps={{
        style: { zIndex: 1000000 },
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 4],
            },
          },
        ],
      }}
      {...openProp}
    >
      {children}
    </Tooltip>
  );
};

export default ButtonTooltip;
